export type LogKey = 'start' | 'copy' | 'frame';

const useLogger = () => {
  // 로깅 통신 중단: 인터페이스는 유지하고 동작은 no-op 처리
  const log = (_key: LogKey) => {
    return;
  };

  const errorLog = (_reason: string) => {
    return;
  };

  return {
    log,
    errorLog,
  };
};

export default useLogger;
